import { useMemo } from 'react';
import CompleteActivityFields from './sections/fields';
import CompleteActivityObjects from './sections/relatedObjects';
import { useKeyListeners } from 'hooks/keyboardEventHandler/useKeyListeners';
import { KeyBoardContext } from 'hooks/keyboardEventHandler/useKeyBoardContext';

import { OBJECT_ASSOCATIONS } from 'components/GenericWizard/wizards/scheduleActivity';
import { useCompleteActivityWizardContext } from './context';

const CompleteActivitytWizard = ({
  associationErrors,
  showErrors,
  setShowErrors,
  setAssociationErrors,
}) => {
  const { activity, activityRelatedObjects, formData } =
    useCompleteActivityWizardContext();

  const { id: activityId, associationMode, layout = [] } = activity ?? {};
  const { fields } = formData;

  const fieldsData = useMemo(() => {
    const fieldsById = fields.reduce((acc, field) => {
      acc[field.id] = field;
      return acc;
    }, {});

    const orderedFields = layout.reduce((acc, item) => {
      if (item.type === 'field' && fieldsById[item.fieldId]) {
        acc.push(fieldsById[item.fieldId]);
      }

      return acc;
    }, []);

    return activityRelatedObjects.concat(orderedFields);
  }, [activityRelatedObjects, fields, layout]);

  const { assignFieldHandle, getKeyListenersProps } = useKeyListeners(
    fieldsData,
    { suppressAutoScroll: true }
  );

  return (
    <KeyBoardContext.Provider value={{ assignFieldHandle }}>
      <>
        {associationMode &&
        associationMode !== OBJECT_ASSOCATIONS.NO_OBJECT_ASSOCIATIONS ? (
          <CompleteActivityObjects
            isLastIndex
            associationErrors={associationErrors}
            getKeyListenersProps={getKeyListenersProps}
            setAssociationErrors={setAssociationErrors}
            setShowErrors={setShowErrors}
          />
        ) : null}
        <CompleteActivityFields
          getKeyListenersProps={getKeyListenersProps}
          associationMode={associationMode}
          activityId={activityId}
          showErrors={showErrors}
          setShowErrors={setShowErrors}
          scheduledActivityId={formData.scheduledActivityId}
        />
      </>
    </KeyBoardContext.Provider>
  );
};

export default CompleteActivitytWizard;
